import React, { useContext } from "react";
import { LendingToolsContext } from "./LendingToolsContext";
import closeSvg from "../../../assets/closeSvg";
import "./LendingTools.css";
import { logActivity } from "../../utils";
import { AppContext } from "../../../AppContext";
import moveTeamImg from "../../../assets/moveTeamImg";

const LendingTools = () => {
  const { makeKey, userEmail, userType, userCompany } = useContext(AppContext);
  const { lendingToolsVisible, setLendingToolsVisible } =
    useContext(LendingToolsContext);

  return (
    <div className={`${lendingToolsVisible}`}>
      <div className="lendingTools-container">
        <div className="thePlaySection">
          <div className="tenPx"></div>
          <div className="tenPx"></div>
          <div className="workshopMaterialsHeader">
            <span>Lending Tools</span>
            <span
              className="close"
              onClick={() => {
                setLendingToolsVisible("fullScreen down");
              }}
            >
              {closeSvg}
            </span>
          </div>
          <div className="tenPx"></div>
          <div className="tenPx"></div>
          <div className="thePlayStep">
            {moveTeamImg}
            &nbsp;&nbsp;<b>Move Mortgage</b>
            <hr></hr>Check out the Move flyer that can be used for open houses.
            The 3-2-1 Buy Down calculator can be used to educate clients on buy
            down options.
            <div className="tenPx"></div>
            <ul className="playSectionMaterialsList">
              <a
                className="workshopMaterialIcon"
                tabIndex={-1}
                href={
                  "https://www.movemortgage.com/wp-content/uploads/2023/09/No-Pressure-Clients-for-life-Flyer.pdf"
                }
                rel="noopener noreferrer"
                target="_blank"
                onClick={() => {
                  logActivity({
                    apiKey: makeKey,
                    userEmail: userEmail,
                    userType: userType,
                    action: "Opened Move Flyer",
                    tab: "Lending Tools",
                    userCompany: userCompany,
                  });
                }}
              >
                <span className="workshopMaterialText">
                  <b>Open House</b> Flyer
                </span>
              </a>
              <a
                className="workshopMaterialIcon"
                tabIndex={-1}
                href={
                  "https://docs.google.com/spreadsheets/d/12aI17BLspscK2AK0r_cw9_sKNbrWDy6LqymCj-MZwa0/edit#gid=762581956"
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="workshopMaterialText">
                  <b>
                    3-2-1<br></br>Buy Down
                  </b>
                  <br></br>Calculator
                </span>
              </a>
            </ul>
          </div>
          <div className="twentyFivePx"></div>
          <div className="thePlayStep">
            <b>Tools & Calculators</b>
            <hr></hr>Quick and easy-to-use calcualtor to educate your clients on
            the benefits of buying vs renting.
            <div className="tenPx"></div>
            <ul className="playSectionMaterialsList">
              <a
                className="workshopMaterialIcon"
                tabIndex={-1}
                href={"https://www.zillow.com/rent-vs-buy-calculator"}
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="workshopMaterialText">
                  <b>Rent vs Buy</b>
                  <br></br>Calculator
                </span>
              </a>
              <a
                className="workshopMaterialIcon"
                tabIndex={-1}
                href={"https://movemortgageapplication.floify.com/"}
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="workshopMaterialText">
                  <b>Monthly Payment</b> Calculator
                </span>
              </a>
            </ul>
          </div>
          <div className="oneHundredPx"></div>
        </div>
      </div>
    </div>
  );
};

export default LendingTools;
